import React, { Component } from 'react';
import { Button, Icon, Spin } from 'antd';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route } from "react-router";

import { actions } from "store";
import { Page, PageHeader } from 'components/layout';
import { ActionButton } from "components/common";
import { SalonForm } from 'components/blocks/Salon';
import SalonMainScreen from './SalonMainScreen';
import SalonReviewListScreen from './SalonReviewListScreen';


class SalonDetailScreen extends Component {
  state = {
    id: null,
  };

  componentDidMount() {
    const { actions, match } = this.props;
    actions.salonDetailLoad({ id: match.params.id });
    this.setState({ id: match.params.id });
  }

  showEditForm = (item = null) => {
    const { actions } = this.props;
    actions.salonShowEditForm({ show: true, object: item });
  };

  delete = () => {
    const { actions } = this.props;
    const { id } = this.state;
    actions.salonDelete({ id });
  };

  render() {
    const { history, salon } = this.props;
    const detail = salon.detail || {};

    return (
      <Page>
        <Spin spinning={salon.updateStatus.isLoading}>
          <PageHeader
            history={history}
            title={detail.name}
            actions={[
              <Button onClick={() => this.showEditForm(detail)}>
                <Icon type="plus"/>
                <span>Редактировать</span>
              </Button>,
              <ActionButton
                actions={[
                  {
                    key: 'delete',
                    icon: 'delete',
                    title: 'Удалить',
                    action: this.delete,
                    confirm: {
                      title: 'Уверены, что хотите удалить?',
                      okText: 'Удалить',
                      cancelText: 'Отмена'
                    }
                  },
                ]}
              />
            ]}
            basePath={`/salon/${this.state.id}`}
            tabs={[
              { title: 'Детали', key: 'detail' },
              { title: 'Отзывы', key: 'reviews' },
            ]}
          />

          <Route exact path="/salon/:id" component={SalonMainScreen}/>
          <Route exact path="/salon/:id/reviews" component={SalonReviewListScreen}/>

          <SalonForm/>
        </Spin>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    salon: state.salon,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.salon), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SalonDetailScreen);
